import { Routes } from '@angular/router';
import { accesoAppGuard } from './guard/acceso-app.guard';
import { accesoLoginGuard } from './guard/acceso-login.guard';
import { accesoSucursalGuard } from './guard/acceso-sucursal.guard';
import { hasAccessGuard } from 'guard/has-access.guard';
import { hasAccessModuleGuard } from 'guard/has-access-module.guard';
import { MODULO_ARCHIVOS } from '@archivos/accesos';
import { MODULO_PRODUCCION } from './modulos/produccion/accesos';

export const routes: Routes = [
    { path: 'login', loadComponent: () => import('./auth/features/login/login.component').then(c => c.LoginComponent), canActivate: [accesoLoginGuard] },
    { path: 'login/:usersesion', loadComponent: () => import('./auth/features/login/login.component').then(c => c.LoginComponent) },
    { path: 'recuperar-clave', loadComponent: () => import('./auth/features/recover-password/recover-password.component').then(c => c.RecoverPasswordComponentMain) },
    { path: 'clave-expirada', loadComponent: () => import('./auth/features/expired-password/expired-password.component').then(c => c.ExpiredPasswordComponentMain) },
    { path: 'seleccionar-sucursal', loadComponent: () => import('./auth/features/select-branch/select-branch.component').then(c => c.SelectBranchComponentMain), canActivate: [accesoAppGuard] },
    {
        path: '', loadComponent: () => import('./layouts/features/full/full.component').then(c => c.FullComponent),
        canMatch:[hasAccessGuard],
        canActivate: [accesoSucursalGuard], 
        children: [
            // Portada igual que el legacy (app-routing.module.ts): '' -> /dashboard
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'archivos',
                canActivate: [hasAccessModuleGuard(MODULO_ARCHIVOS.ID)], 
                loadChildren: () => import('./modulos/archivos/archivos.routes') },
            { path: 'produccion',
                canActivate: [hasAccessModuleGuard(MODULO_PRODUCCION.ID)],
                loadChildren: () => import('./modulos/produccion/produccion.routes') },
            { path: 'dashboard', loadChildren: () => import('./modulos/dashboard/dashboard.routes') },
            { path: 'atajos', loadComponent: () => import('./layouts/features/atajos/atajos.component') }
        ]
    },
    { path: 'unauthorized', loadComponent: () => import('./layouts/features/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent) },
    { path: '**', loadComponent: () => import('layout-tsi').then(m => m.NotFoundComponent) }
]
